module.exports = __webpack_public_path__ + "static/img/ravesafe.2e1e221.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ravesafe.png
// module id = 5FIK
// module chunks = 0